import { i18n } from '../i18n';

const relativeTimeFormatter = (diffInSeconds: number) => {
  const timeUnits = [
    { label: i18n.t('common.relativeTime.years'), seconds: 31536000 },
    { label: i18n.t('common.relativeTime.months'), seconds: 2592000 },
    { label: i18n.t('common.relativeTime.weeks'), seconds: 604800 },
    { label: i18n.t('common.relativeTime.days'), seconds: 86400 },
    { label: i18n.t('common.relativeTime.hours'), seconds: 3600 },
    { label: i18n.t('common.relativeTime.minutes'), seconds: 60 },
    { label: i18n.t('common.relativeTime.seconds'), seconds: 1 },
  ];

  for (const unit of timeUnits) {
    if (diffInSeconds >= unit.seconds) {
      const value = Math.floor(diffInSeconds / unit.seconds);
      return value > 1 ? `${value}${unit.label}` : `1${unit.label}`;
    }
  }
  return i18n.t('common.relativeTime.fewSeconds');
};

export const formatRelativeTime = (date: number | string | Date) => {
  const now = Date.now();
  const past = new Date(date).getTime();
  const diffInSeconds = Math.floor((now - past) / 1000);
  const absDiffInSeconds = Math.abs(diffInSeconds);
  const formatted = relativeTimeFormatter(absDiffInSeconds);

  return diffInSeconds > 0 ? formatted : i18n.t('common.relativeTime.future', { time: formatted });
};
